import {
  call, put, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import downloadHelper from '@/utils/downloads';
import CataloguesService from '../service';
import {
  downloadDatasetCatalogueError,
  showCatalogue,
  showCatalogueError,
} from '../actions';
import actions from '../constants';

export function* catalogue({ category, code, intl }) {
  const { response, error } = yield call(callAdapter, CataloguesService.catalogue(code));
  if (error) {
    yield put(showCatalogueError(category, code, error));
  } else {
    yield put(showCatalogue(category, code, response, intl));
  }
}

export function* download({ code }) {
  const { response, error } = yield call(callAdapter, CataloguesService.catalogue(code));
  if (error) {
    yield put(downloadDatasetCatalogueError(code, error));
  } else {
    downloadHelper.jsonDownload(response, `${code}_catalogue.json`);
  }
}

export default function* cataloguesApi() {
  yield takeEvery(actions.FETCH_CATALOGUE, catalogue);
  yield takeEvery(actions.DOWNLOAD_CATALOGUE, download);
}
